import { defineMessages } from 'react-intl';

const messages = defineMessages({
  action: {
    id: 'categorydata.action',
    defaultMessage: 'Action',
  },
  adventure: {
    id: 'categorydata.adventure',
    defaultMessage: 'Adventure',
  },
  anime: {
    id: 'categorydata.anime',
    defaultMessage: 'Anime',
  },
  basebuilding: {
    id: 'categorydata.basebuilding',
    defaultMessage: 'Base Building',
  },
  beatemup: {
    id: 'categorydata.beatemup',
    defaultMessage: 'Beat em up',
  },
  casual: {
    id: 'categorydata.casual',
    defaultMessage: 'Casual',
  },
  citybuilder: {
    id: 'categorydata.citybuilder',
    defaultMessage: 'City Builder',
  },
  coop: {
    id: 'categorydata.coop',
    defaultMessage: 'Co-Op',
  },
  crafting: {
    id: 'categorydata.crafting',
    defaultMessage: 'Crafting',
  },
  dungeoncrawler: {
    id: 'categorydata.dungeoncrawler',
    defaultMessage: 'Dungeon Crawler',
  },
  familyfriendly: {
    id: 'categorydata.familyfriendly',
    defaultMessage: 'Family Friendly',
  },
  firstpersonshooter: {
    id: 'categorydata.firstpersonshooter',
    defaultMessage: 'First Person Shooter',
  },
  grandstrategy: {
    id: 'categorydata.grandstrategy',
    defaultMessage: 'Grand Strategy',
  },
  hackandslash: {
    id: 'categorydata.hackandslash',
    defaultMessage: 'Hack and Slash',
  },
  horror: {
    id: 'categorydata.horror',
    defaultMessage: 'Horror',
  },
  hiddenobject: {
    id: 'categorydata.hiddenobject',
    defaultMessage: 'Hidden Object',
  },
  jrpg: {
    id: 'categorydata.jrpg',
    defaultMessage: 'JRPG',
  },
  management: {
    id: 'categorydata.management',
    defaultMessage: 'Management',
  },
  military: {
    id: 'categorydata.military',
    defaultMessage: 'Military',
  },
  multiplayer: {
    id: 'categorydata.multiplayer',
    defaultMessage: 'Multiplayer',
  },
  onlinecoop: {
    id: 'categorydata.onlinecoop',
    defaultMessage: 'Online Co-Op',
  },
  openworld: {
    id: 'categorydata.openworld',
    defaultMessage: 'Open World',
  },
  platformer: {
    id: 'categorydata.platformer',
    defaultMessage: 'Platformer',
  },
  postapocalyptic: {
    id: 'categorydata.postapocalyptic',
    defaultMessage: 'Post-apocalyptic',
  },
  puzzle: {
    id: 'categorydata.puzzle',
    defaultMessage: 'Puzzle',
  },
  racing: {
    id: 'categoryData.racing',
    defaultMessage: 'Racing',
  },
  roguelike: {
    id: 'categoryData.roguelike',
    defaultMessage: 'Rogue Like',
  },
  relaxing: {
    id: 'categorydata.relaxing',
    defaultMessage: 'Relaxing',
  },
  retro: {
    id: 'categorydata.retro',
    defaultMessage: 'Retro',
  },
  roleplaying: {
    id: 'categorydata.roleplaying',
    defaultMessage: 'Role-Playing',
  },
  sandbox: {
    id: 'categorydata.sandbox',
    defaultMessage: 'Sandbox',
  },
  scifi: {
    id: 'categorydata.scifi',
    defaultMessage: 'Sci-fi',
  },
  soulslike: {
    id: 'categorydata.soulslike',
    defaultMessage: 'Souls-like',
  },
  space: {
    id: 'categorydata.space',
    defaultMessage: 'Space',
  },
  sports: {
    id: 'categorydata.sports',
    defaultMessage: 'Sports',
  },
  strategy: {
    id: 'categorydata.strategy',
    defaultMessage: 'Strategy',
  },
  simulation: {
    id: 'categorydata.simulation',
    defaultMessage: 'Simulation',
  },
  metroidvania: {
    id: 'categorydata.metroidvania',
    defaultMessage: 'Metroidvania',
  },
  survival: {
    id: 'categorydata.survival',
    defaultMessage: 'Survival',
  },
  tabletop: {
    id: 'categorydata.tabletop',
    defaultMessage: 'Tabletop',
  },
  turnbasedstrategy: {
    id: 'categorydata.turnbasedstrategy',
    defaultMessage: 'Turn-Based Strategy',
  },
  zombies: {
    id: 'categorydata.zombies',
    defaultMessage: 'Zombies',
  },
  viewall: {
    id: 'categorydata.viewall',
    defaultMessage: 'View All',
  },
});

const categoryData = [
  { name: messages.action, to: '/categories/action' },
  { name: messages.adventure, to: '/categories/adventure' },
  { name: messages.casual, to: '/categories/casual' },
  { name: messages.citybuilder, to: '/categories/city-builder' },
  { name: messages.onlinecoop, to: '/categories/online-co-op' },
  { name: messages.anime, to: '/categories/anime' },
  { name: messages.firstpersonshooter, to: '/categories/fps' },
  { name: messages.familyfriendly, to: '/categories/family-friendly' },
  { name: messages.hackandslash, to: '/categories/hack-and-slash' },
  { name: messages.horror, to: '/categories/horror' },
  { name: messages.jrpg, to: '/categories/jrpg' },
  { name: messages.grandstrategy, to: '/categories/grand-strategy' },
  { name: messages.multiplayer, to: '/categories/multiplayer' },
  { name: messages.management, to: '/categories/management' },
  { name: messages.openworld, to: '/categories/open-world' },
  { name: messages.platformer, to: '/categories/platformer' },
  { name: messages.hiddenobject, to: '/categories/hidden-object' },
  { name: messages.puzzle, to: '/categories/puzzle' },
  { name: messages.racing, to: '/categories/racing' },
  { name: messages.roguelike, to: '/categories/roguelike' },
  { name: messages.roleplaying, to: '/categories/rpg' },
  { name: messages.scifi, to: '/categories/sci-fi' },
  { name: messages.simulation, to: '/categories/simulation' },
  { name: messages.metroidvania, to: '/categories/metroidvania' },
  { name: messages.sports, to: '/categories/sports' },
  { name: messages.survival, to: '/categories/survival' },
  { name: messages.strategy, to: '/categories/strategy' },
  { name: messages.turnbasedstrategy, to: '/categories/turn-based-strategy' },
  { name: messages.zombies, to: '/categories/zombies' },
  { name: messages.viewall, to: '/categories' },
];

export default categoryData;
